import { getRouteApi } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import BasicLayout from '@/components/common/BasicLayout/BasicLayout'
import { toast } from '@/hooks/useToast'

import CurriculumForm from '../components/CurriculumForm'
import type { CurriculumFormStep } from '../hooks/useCurriculumForm'
import useAddCurriculum from '../mutations/useAddCurriculum'

const routeApi = getRouteApi('/_auth/curricula/add')

const CurriculumsManagementAdd = () => {
  const navigate = routeApi.useNavigate()
  const { t } = useTranslation('curriculumsManagement')

  const { mutate: addCurriculum, isPending } = useAddCurriculum({
    onSuccess: ({ variables, response }) => {
      toast({
        variant: 'success',
        title: t('toast.add-success', { NAME: variables.name })
      })

      navigate({
        to: '/curricula/$curriculumId',
        params: { curriculumId: response.id }
      })
    },
    onError: ({ variables }) => {
      toast({
        variant: 'error',
        title: t('toast.add-error', { NAME: variables.name })
      })
    }
  })

  const { mutate: saveAsDraft, isPending: isSavingAsDraft } = useAddCurriculum({
    saveAsDraft: true,
    onSuccess: ({ variables }) => {
      toast({
        variant: 'success',
        title: t('toast.save-as-draft-success', { NAME: variables.name })
      })
    },
    onError: ({ variables }) => {
      toast({
        variant: 'error',
        title: t('toast.save-as-draft-error', { NAME: variables.name })
      })
    }
  })

  const handleSubmit = (data: CurriculumFormStep) => {
    if (!('baskets' in data)) return

    addCurriculum(data)
  }

  const handleSaveAsDraft = (data: CurriculumFormStep) => {
    if (!('baskets' in data)) return

    saveAsDraft(data)
  }

  return (
    <BasicLayout
      header={t('header.add-new-curriculum')}
      breadcrumbs={[
        {
          title: t('header.curricula'),
          to: '/curricula'
        },
        {
          title: t('header.add-new-curriculum')
        }
      ]}
      moduleName={t('header.administration', { ns: 'common' })}
    >
      <CurriculumForm
        isLoading={isPending || isSavingAsDraft}
        onSubmit={handleSubmit}
        onSaveAsDraft={handleSaveAsDraft}
      />
    </BasicLayout>
  )
}

export default CurriculumsManagementAdd
